import { render, staticRenderFns } from "./TBtn.vue?vue&type=template&id=6e9e5d80"
import script from "./TBtn.vue?vue&type=script&lang=js"
export * from "./TBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports